import { CellContext } from "@tanstack/react-table";
import { memo } from "react";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { formatDateForTransaction } from "../../../helpers/date";
import styles from "./DateCell.module.scss";

export const DateCell = memo(
    ({ getValue }: CellContext<TransactionListItemDto, Date>) => (
        <div className={styles.dateCell}>
            {formatDateForTransaction(getValue())}
        </div>
    ),
);
